import type { IOffer } from 'shared/offer';

export function getIsCpcAuction(offer: IOffer): boolean {
  return !!offer?.auction?.isCpcAuction;
}
